import React from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import useAuth from "../../hooks/useAuth";
import { useProject } from "../../contexts/project";

export default function CaptureActionsLegacy({
  disabled,
  onSave,
  onCreate,
  onDuplicate,
  onRemove,
  onTransfer,
  projectId,
  disableSave,
  canWrite = true,
}) {
  const { user } = useAuth();
  const { settings } = user?.company || {};
  const currentProject = useProject();

  const showDuplicate = onDuplicate && canWrite && (
    projectId 
      ? !currentProject?.storageEnabled
      : !settings.receiving_wizard
  );
  const showRemove = onRemove && canWrite;
  const showTransfer = onTransfer && canWrite;
  const showSave = onSave && canWrite;
  const showCreate = onCreate && canWrite;

  return (
    <Card>
      <CardContent>
        <Box display="flex" justifyContent="flex-end" gap={1}>
          {showRemove && (
            <Box flex="1 1 0" maxWidth="200px">
              <Button
                disabled={disabled || !onRemove}
                id="RemoveAsset"
                data-id="remove-asset"
                fullWidth
                variant="outlined"
                color="error"
                onClick={onRemove}
              >
                Remove
              </Button>
            </Box>
          )}
          {showTransfer && (
            <Box flex="1 1 0" maxWidth="200px">
              <Button
                disabled={disabled || !onTransfer}
                id="TransferAsset"
                data-id="transfer-asset"
                fullWidth
                variant="outlined"
                onClick={onTransfer}
              >
                Transfer
              </Button>
            </Box>
          )}
          {showDuplicate && (
            <Box flex="1 1 0" maxWidth="200px">
              <Button
                disabled={disabled || !onDuplicate}
                id="duplicateAsset"
                data-id="duplicate-asset"
                fullWidth
                variant="outlined"
                onClick={onDuplicate}
              >
                Duplicate
              </Button>
            </Box>
          )}
          {showSave && (
            <Box flex="1 1 0" maxWidth="200px">
              <Button
                disabled={disabled || !onSave || disableSave}
                id="saveAsset"
                data-id="save-asset"
                fullWidth
                variant="outlined"
                onClick={onSave}
              >
                Save
              </Button>
            </Box>
          )}
          {showCreate && (
            <Box flex="1 1 0" maxWidth="200px">
              <Button
                disabled={disabled || !projectId || !onCreate}
                id="addNewAsset"
                data-id="add-new-asset"
                fullWidth
                variant="contained"
                color="primary"
                onClick={onCreate}
              >
                Add New
              </Button>
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
}
